import css from "styled-jsx/css";

export default css`
  .histogram-sketelon {
    display: flex;
    width: 100%;
    height: auto;
    margin: 2rem;
    flex-direction: column;
    &--title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 16px;
      width: 100px;
    }
    &--container {
      gap: 1rem;
      justify-content: center;
      display: flex;
      flex-direction: row;
      align-items: end;
      width: 100%;
      &--bar--small {
        width: 10px;
        height: 120px;
        border-radius: 6px;
      }
      &--bar--medium {
        width: 10px;
        height: 150px;
        border-radius: 6px;
      }
    }
  }
  .fadeOutBuyCardSkeleton {
    opacity: 1;
    animation: fadeOutAnimation 1s ease;
  }
  @keyframes fadeOutAnimation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
